import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issuetype: {
		id: 'business-list.list-view.column-header.issuetype',
		defaultMessage: 'Type',
		description: 'Title for Issue Type column',
	},
	issuekey: {
		id: 'business-list.list-view.column-header.issuekey',
		defaultMessage: 'Key',
		description: 'Title for Key column',
	},
	summary: {
		id: 'business-list.list-view.column-header.summary',
		defaultMessage: 'Summary',
		description: 'Title for Summary column',
	},
	status: {
		id: 'business-list.list-view.column-header.status',
		defaultMessage: 'Status',
		description: 'Title for Status column',
	},
	assignee: {
		id: 'business-list.list-view.column-header.assignee',
		defaultMessage: 'Assignee',
		description: 'Title for Assignee column',
	},
	labels: {
		id: 'business-list.list-view.column-header.labels',
		defaultMessage: 'Labels',
		description: 'Title for Labels column',
	},
	duedate: {
		id: 'business-list.list-view.column-header.duedate',
		defaultMessage: 'Due date',
		description: 'Title for Due date column',
	},
	priority: {
		id: 'business-list.list-view.column-header.priority',
		defaultMessage: 'Priority',
		description: 'Title for Priority column',
	},
	created: {
		id: 'business-list.list-view.column-header.created',
		defaultMessage: 'Created',
		description: 'Title for created date column',
	},
	updated: {
		id: 'business-list.list-view.column-header.updated',
		defaultMessage: 'Updated',
		description: 'Title for updated date column',
	},
});
